const PlayIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.50275 16.8718L1.71973 20.6548L3.10566 22.0407L6.88868 18.2577L5.50275 16.8718Z" fill="#EA8500" />
        <path d="M19.2299 1.85002L5.91992 16.4L6.63992 17.12L22.9999 0.77002L19.2299 1.85002Z" fill="#E0E0E0" />
        <path d="M21.9101 4.54002L23.0001 0.77002L6.64014 17.12L7.37014 17.85L21.9101 4.54002Z" fill="#C4C4C4" />
        <path
            d="M6.98023 16.7902L4.66023 13.7002L3.49023 14.8602L6.18023 17.5502L6.22023 17.5902L8.90023 20.2702L10.0702 19.1002L6.98023 16.7902Z"
            fill="#FFAB24"
        />
        <path
            d="M2.41 22.7599C3.18872 22.7599 3.82 22.1287 3.82 21.3499C3.82 20.5712 3.18872 19.9399 2.41 19.9399C1.63128 19.9399 1 20.5712 1 21.3499C1 22.1287 1.63128 22.7599 2.41 22.7599Z"
            fill="#FFAB24"
        />
        <path d="M18.4982 16.8865L17.1123 18.2725L20.8953 22.0555L22.2813 20.6696L18.4982 16.8865Z" fill="#EA8500" />
        <path d="M4.77 1.85002L18.08 16.4L17.36 17.12L1 0.77002L4.77 1.85002Z" fill="#E0E0E0" />
        <path d="M2.09 4.54002L1 0.77002L17.36 17.12L16.63 17.85L2.09 4.54002Z" fill="#C4C4C4" />
        <path
            d="M17.0202 16.7902L19.3402 13.7002L20.5102 14.8602L17.8202 17.5502L17.7802 17.5902L15.1002 20.2702L13.9302 19.1002L17.0202 16.7902Z"
            fill="#FFAB24"
        />
        <path
            d="M21.5902 22.7599C22.3689 22.7599 23.0002 22.1287 23.0002 21.3499C23.0002 20.5712 22.3689 19.9399 21.5902 19.9399C20.8115 19.9399 20.1802 20.5712 20.1802 21.3499C20.1802 22.1287 20.8115 22.7599 21.5902 22.7599Z"
            fill="#FFAB24"
        />
        <path
            d="M16.2402 2.77002V4.57002H12.8202V2.77002H11.1202V4.57002H7.7002C7.7002 5.56002 8.4602 6.37002 9.4102 6.37002H14.2702C15.2102 6.37002 15.9802 5.56002 15.9802 4.57002V2.77002H16.2402Z"
            fill="#FFAB24"
        />
        <path
            d="M7.71 4.57002V2.77002H6V4.57002C6 5.56002 6.76 6.37002 7.71 6.37002H9.42C8.48 6.37002 7.71 5.56002 7.71 4.57002Z"
            fill="#FFCB57"
        />
        <path
            d="M15.7 6.37002H16.23C17.17 6.37002 17.94 5.56002 17.94 4.57002V2.77002H15.98V4.57002C15.98 5.56002 15.22 6.37002 14.27 6.37002H15.7Z"
            fill="#EA8500"
        />
        <path d="M16.1999 6.37012H7.66992V17.1701H16.1999V6.37012Z" fill="#FFAB24" />
        <path
            d="M7.81006 17.1699H16.2501C17.2201 17.1699 18.0001 17.9599 18.0001 18.9199V20.7699H6.06006V18.9199C6.06006 17.9499 6.85006 17.1699 7.81006 17.1699Z"
            fill="#FFAB24"
        />
        <path d="M16.21 6.37012H14.5V17.1701H16.21V6.37012Z" fill="#EA8500" />
        <path d="M9.37992 6.37012H7.66992V17.1701H9.37992V6.37012Z" fill="#FFCB57" />
        <path d="M11.08 6.37012H10.23V17.1701H11.08V6.37012Z" fill="#FFCB57" />
        <path
            d="M7.7598 18.9699V20.7699H6.0498V18.9699C6.0498 17.9799 6.8098 17.1699 7.7598 17.1699H9.4698C8.5298 17.1699 7.7598 17.9799 7.7598 18.9699Z"
            fill="#FFCB57"
        />
        <path
            d="M15.7601 17.1699H16.2901C17.2301 17.1699 18.0001 17.9799 18.0001 18.9699V20.7699H16.0401V18.9699C16.0401 17.9799 15.2801 17.1699 14.3301 17.1699H15.7601Z"
            fill="#EA8500"
        />
        <path
            d="M17.94 2.77002V4.57002C17.94 5.56002 17.18 6.37002 16.23 6.37002H16.19V17.17H16.28C16.73 17.17 17.13 17.35 17.43 17.65C17.45 17.67 17.47 17.68 17.49 17.7C17.51 17.72 17.52 17.74 17.53 17.75C17.81 18.07 17.99 18.49 17.99 18.96V20.76H6.06V18.96C6.06 18.49 6.24 18.06 6.52 17.74C6.54 17.72 6.55 17.7 6.56 17.69C6.58 17.67 6.6 17.66 6.62 17.64C6.92 17.35 7.33 17.16 7.77 17.16H7.68V6.37002H7.71C6.77 6.37002 6 5.56002 6 4.57002V2.77002H7.7V4.57002H11.12V2.77002H12.82V4.57002H16.24V2.77002H17.94ZM18.94 1.77002H15.24V3.57002H13.82V1.77002H10.12V3.57002H8.7V1.77002H5V4.57002C5 5.73002 5.69 6.74002 6.67 7.16002V16.41C6.41 16.53 6.16 16.7 5.94 16.91C5.9 16.94 5.87 16.97 5.84 17L5.79 17.05L5.74 17.12C5.3 17.64 5.06 18.29 5.06 18.97V21.77H19V18.97C19 18.29 18.76 17.63 18.32 17.12C18.29 17.08 18.27 17.05 18.24 17.02L18.19 16.97L18.12 16.91C17.85 16.65 17.54 16.46 17.2 16.34V7.18002C18.22 6.77002 18.94 5.76002 18.94 4.57002V1.77002Z"
            fill="#682A00"
        />
    </svg>
)

PlayIcon.displayName = 'PlayIcon'

export default PlayIcon
